import React from 'react';

import { Box, Typography } from '@rbilabs/universal-components';
import { View } from 'react-native';

import { useProductCalories } from 'pages/menu/components/product-wizard/use-product-calories';
import { useProductTotalPrice } from 'pages/menu/components/product-wizard/use-product-total-price';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

import { OverSodiumLimitWarning } from './over-sodium-limit-warning';
import { ProductPriceCaloriesContainer } from './styled';

interface ProductPriceCaloriesProps {
  showPlusSign?: boolean;
}

export const ProductPriceCalories = ({ showPlusSign }: ProductPriceCaloriesProps) => {
  const { selectedProduct, slotsSelections, productQuantity } = useProductWizardContext();
  const { cartIdEditing, id, rewardId } = useProductWizardFlow();
  const { formattedTotalPrice } = useProductTotalPrice({
    id,
    selectedProduct,
    slotsSelections,
    productQuantity,
    cartIdEditing,
    rewardId,
  });
  const calories = useProductCalories(selectedProduct);

  const accessibilityLabel = `${formattedTotalPrice} ${calories}`;

  return (
    <Box focusable accessibilityLabel={accessibilityLabel}>
      <ProductPriceCaloriesContainer>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          {formattedTotalPrice && (
            <Typography fontSize="lg" testID="product-total-price">
              {formattedTotalPrice}
            </Typography>
          )}
          {formattedTotalPrice && calories && <Typography fontSize="lg">{' | '}</Typography>}
          {calories && (
            <Typography testID="product-total-calories" fontSize="lg">
              {calories}
            </Typography>
          )}
        </View>
        <OverSodiumLimitWarning />
      </ProductPriceCaloriesContainer>
    </Box>
  );
};
